import React, { FC } from 'react'

import { AddNewStory } from 'modules/Feed/components'
import { useAddNewFeed } from 'modules/Feed/serviceHooks'
import { useTags } from 'modulesCommon/Tags/useTags'
import { useCurrentUser } from 'modules/User/useCurrentUser'

const AddNewStoryContainer: FC<{ isFeedPage: boolean }> = ({ isFeedPage, children }) => {
  const {
    createFeedHandler,
    searchItemsHandler,
    searchResult,
    storyGuide,
    isEditorLoading,
    isEditorActive,
    toggleHandler,
    spaceId,
    currentLabelId
  } = useAddNewFeed()
  const { user } = useCurrentUser()
  const { tags } = useTags({ labelId: currentLabelId ?? user?.label_id, spaceId: spaceId ?? user?.space_id })


  return (
    <AddNewStory
      isEditorActive={isEditorActive}
      toggleHandler={toggleHandler}
      isEditorLoading={isEditorLoading}
      feedHandler={createFeedHandler}
      tags={tags}
      searchItems={searchItemsHandler}
      searchResult={searchResult}
      storyGuide={storyGuide}
      isFeedPage={isFeedPage}
    >
      {children}
    </AddNewStory>
  )
}

export default AddNewStoryContainer
